import { createSelector } from 'reselect';

import getLocations from './getLocations';
import getLocationId, { $getLocationId } from './getLocationId';

const get = (
  allLocations: SDict<POSLocation> | undefined,
  currentLocationId: string | undefined,
): POSLocation | undefined => {
  if (!allLocations || currentLocationId === undefined) {
    return undefined;
  }
  return allLocations[currentLocationId];
};

export default createSelector([getLocations, getLocationId], get);

export const $getLocation = createSelector([getLocations, $getLocationId], get);
